'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import moment from 'moment';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _support = require('helpers/support');

var _reactRedux = require('react-redux');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentHistory = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    dataHistory: state.payment.dataHistory
  };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PaymentHistory, _Component);

  function PaymentHistory() {
    (0, _classCallCheck3.default)(this, PaymentHistory);
    return (0, _possibleConstructorReturn3.default)(this, (PaymentHistory.__proto__ || (0, _getPrototypeOf2.default)(PaymentHistory)).apply(this, arguments));
  }

  (0, _createClass3.default)(PaymentHistory, [{
    key: 'render',
    value: function render() {
      var styles = require('./PaymentHistory.scss');
      var dataHistory = this.props.dataHistory;

      _support.Helper.isDev();
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'section',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.head },
              _react2.default.createElement(
                'span',
                { className: styles.type },
                'Th\u1EBB'
              ),
              _react2.default.createElement(
                'span',
                { className: styles.amount },
                'S\u1ED1 ti\u1EC1n'
              ),
              _react2.default.createElement(
                'span',
                { className: styles.time },
                'Th\u1EDDi gian'
              )
            ),
            !!(dataHistory && dataHistory.length) && dataHistory.map(function (v) {
              return _react2.default.createElement(_components.HistoryCard, {
                className: styles.card,
                icon: v.img,
                amount: v.amount,
                date: v.time
              });
            })
          )
        )
      );
    }
  }]);
  return PaymentHistory;
}(_react.Component), _class2.propTypes = {
  // @action
  dataHistory: _react.PropTypes.array
}, _temp)) || _class);
exports.default = PaymentHistory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Payment/PaymentHistory.js
// module id = 1619
// module chunks = 0